<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
    label-position="top"
  >
    <!-- payment link created -->
    <div v-if="isCreatedView || isUpdatedView">
      <div class="flex flex-col items-center justify-center">
        <check-mark-icon />
        <h3
          style="word-break: normal"
          class="text-root-2 text-xl text-center md:w-3/4 mt-8"
        >
          Payment link {{ view }} successfully
        </h3>
        <p v-if="createdPaymentLinkDetails" class="text-xs font-light">
          Share your payment to start receiving payment
        </p>
      </div>
      <ul
        v-if="createdPaymentLinkDetails"
        class="border px-3 py-3 my-8 rounded-lg bg-root-3 text-xs font-light"
      >
        <li class="flex items-center justify-between mb-6">
          <span>Link Title</span>
          <span class="font-semibold text-root-2">{{
            createdPaymentLinkDetails.title || ''
          }}</span>
        </li>
        <li class="flex items-center justify-between">
          <span>Amount to Pay</span>
          <span class="font-semibold text-root-2">{{
            parseMoneyAll(
              createdPaymentLinkDetails.amount.amount,
              createdPaymentLinkDetails.amount.currency
            ) || ''
          }}</span>
        </li>
      </ul>
      <!-- copy link -->
      <div
        v-if="createdPaymentLinkDetails"
        class="flex w-full text-root-4 mb-8"
      >
        <span
          class="w-full border border-primary py-3.5 rounded-lg shadow-sm justify-center cursor-pointer font-light flex items-center gap-x-3 px-2"
          v-clipboard:copy="
            createdPaymentLinkDetails.url || createdPaymentLinkDetails.linkURL
          "
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <span class="truncate text-xs mx-4">{{
            createdPaymentLinkDetails.url || createdPaymentLinkDetails.linkURL
          }}</span>
          <copy-icon />
        </span>
      </div>
      <!-- share button -->
      <div class="flex items-center justify-around">
        <o-button v-if="createdPaymentLinkDetails" @click="shareLinkHandler"
          >Share Link</o-button
        >
        <o-button
          v-if="createdPaymentLinkDetails"
          @click="
            previewCustomerLink(
              createdPaymentLinkDetails.url || createdPaymentLinkDetails.linkURL
            )
          "
          >Preview Link</o-button
        >
      </div>
    </div>
    <!-- share link -->
    <div v-else>
      <div class="flex flex-col items-center justify-center">
        <share-link />
        <h3 class="text-lg md:text-xl text-root-2 font-semibold mt-4 mb-2">
          Share Link
        </h3>
        <p class="font-light text-xs mb-5">
          share your payment link to start receiving payment
        </p>
      </div>
      <el-form
        :model="shareLinkForm"
        :rules="rules"
        label-position="top"
        ref="shareLinkForm"
      >
        <el-form-item prop="email">
          <div class="flex items-center">
            <el-input
              type="email"
              v-model="shareLinkForm.email"
              placeholder="Enter Email Address"
            />
            <o-button
              class="-ml-10 relative z-10 py-3"
              @click="submitForm('shareLinkForm')"
              >Share Link</o-button
            >
          </div>
        </el-form-item></el-form
      >
      <!-- another copy link -->
      <div class="flex w-full text-root-4 mt-3">
        <span
          class="w-full justify-center cursor-pointer font-light flex items-center gap-x-3"
          v-clipboard:copy="
            createdPaymentLinkDetails.url || createdPaymentLinkDetails.linkURL
          "
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <span class="text-primary font-normal">Copy Link</span>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { ParseMoneyAll } from '@/utils/helpers.js'
import getPaymentLinks from '@/mixins/paymentLink.js'
export default {
  mixins: [getPaymentLinks],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'created'
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    ShareLink: () => import('@/assets/icons/ShareLink.vue')
  },
  data () {
    return {
      payload: {
        page: 1,
        size: 5,
        status: '',
        type: '',
        from: '',
        to: '',
        sort_direction_desc: true,
        sort_by: 'created_at'
      },
      currentView: this.view,
      shareLinkForm: {
        email: ''
      },
      rules: {
        email: [
          {
            type: 'email',
            required: true,
            message: 'Please enter an email address',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '40%' : '80%'
    },
    createdPaymentLinkDetails () {
      const details = this.$store.state.paymentLink?.createdPaymentLinkDetails
      if (Object.keys(details).length === 0) {
        return null
      }
      return details
    },
    currentPaymentLinkDetails () {
      return this.$store.state.paymentLink.currentPaymentLinkDetails
    },
    isCreatedView () {
      return this.currentView === 'created'
    },
    isUpdatedView () {
      return this.currentView === 'updated'
    }
  },
  methods: {
    previewCustomerLink (url) {
      window.open(url)
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Payment Link Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    shareLinkHandler () {
      this.currentView = 'shareLink'
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          window.location.href = `mailto:${this.shareLinkForm.email}?subject=${
            this.currentPaymentLinkDetails?.title.toUpperCase() ||
            'Payment Link'
          }&body=Link Url: ${
            this.currentPaymentLinkDetails.url ||
            this.createdPaymentLinkDetails.linkURL
          }`
        } else {
          this.$notify({
            showClose: true,
            message: 'Please enter a valid email address',
            type: 'error'
          })
        }
      })
    }
  },
  destroyed () {
    this.$store.dispatch('paymentLink/setCreatedPaymentLinkDetails', {})
    this.getPaymentLinks()
  }
}
</script>

<style scoped>
>>> .el-radio-group {
  display: flex;
  flex-direction: column;
}
>>> .el-radio {
  margin-bottom: 0.8rem;
}
>>> .el-radio__label {
  font-size: 13px;
}
>>> .el-radio__inner {
  height: 18px;
  width: 18px;
}
>>> .el-form-item {
  margin-bottom: -0.5rem;
}
>>> .el-form-item__label {
  font-size: 0.8rem;
  margin-bottom: -0.35rem;
  padding: 0;
}
>>> .el-input__inner {
  border-radius: 1.5rem;
  border: 1px solid var(--color-primary);
}
</style>
